import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "multi-date-picker-hc" }
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "multi-calendar-wrapper",
  ref: "_calendarElementWrapper"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "multi-calendar-element" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "multi-calendar-element" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "multi-calendar-element" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`multi-date-picker ${_ctx.alignLeftStart ? 'multi-date-picker-left' : ''}`),
      ref: "multiDatePicker"
    }, [
      _createElementVNode("input", {
        class: "form form-control pe-4",
        value: _ctx.result,
        ref: "multiDatePickerInput"
      }, null, 8 /* PROPS */, _hoisted_2),
      _withDirectives((_openBlock(), _createElementBlock("span", {
        class: "multi-date-picker-clear",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearResult()))
      }, _hoisted_4)), [
        [_directive_tooltip, { title: `Clear` }]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_9, 512 /* NEED_PATCH */), [
        [_vShow, _ctx.showCalendar]
      ])
    ], 2 /* CLASS */)
  ]))
}